import * as React from 'react';
import { createPortal } from 'react-dom';

const portalContainerId = 'portal-container';

export const ClientSidePortal: React.FC<React.PropsWithChildren> = props => {
    const { children } = props;

    const portalContainer = document.getElementById(portalContainerId);
    const [isAttachedToDOM, setIsAttachedToDOM] = React.useState(false);

    if (!portalContainer) {
        throw new Error(`Portal requires element with id '${portalContainerId}' to be present in DOM`);
    }

    const elementReference = React.useRef<HTMLDivElement | null>(null);

    if (!elementReference.current) {
        elementReference.current = document.createElement('div');
    }

    React.useEffect(() => {
        if (elementReference.current) {
            portalContainer.appendChild(elementReference.current);
            setIsAttachedToDOM(true);
        }

        return () => {
            if (elementReference.current) {
                portalContainer.removeChild(elementReference.current);
                setIsAttachedToDOM(false);
            }
        };
    }, [portalContainer]);

    const portalContent = isAttachedToDOM && children;

    return createPortal(portalContent, elementReference.current);
};
